'use strict';

const loader = require('friartux/components/loader');

const SELECTORS = {
    body: 'body',
    ftoViewLookModal: '#ftoViewLook',
    ftoViewLookBtn: '.js-fto-view-look-btn',
    ftoModalUseBtn: '.js-fto-modal-use-btn',
    generalErrorContainer: '.error-messaging',
}

/**
 * Handle 'ftoViewLookModal' Modal Open
 * @returns {void}
 */
const handleFtoViewLookBtn = (e) => {
    const $this = $(e.currentTarget);
    const useUrl = $this.data('use-look-url');

    $(SELECTORS.ftoModalUseBtn).attr('data-url', useUrl);
}

/**
 * Handle View Look button click
 * @returns {void}
 */
const handleFtoModalBtn = (e) => {
    e.preventDefault();

    // Reuse the PDP add to cart loader; the overlay is left running until the
    // page navigates to the look in the cart, mirroring the PDP redirect.
    loader.start();
    let url = $(e.target).attr('data-url');
    window.location = url;
}


/**
 * Init events
 * @returns {void}
 */
function handleFtoViewLook() {
    $(SELECTORS.body).on('click', SELECTORS.ftoModalUseBtn, handleFtoModalBtn);
    $(SELECTORS.body).on('click', SELECTORS.ftoViewLookBtn, handleFtoViewLookBtn);
}

module.exports = {
    handleFtoViewLook: handleFtoViewLook
};

